import { Text } from '@/components/text';
import { Colors } from '@/constants/theme';
import { useAuthStore } from '@/stores/auth-store';
import { useRouter } from 'expo-router';
import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { DropdownMenu } from './ui/dropdown-menu';
import { UserMenuContent } from './user-menu-content';

export function AuthHeaderMenu() {
  const { isLoggedIn, user, logout } = useAuthStore();
  const router = useRouter();
  const [isOpen, setIsOpen] = React.useState(false);

  if (!isLoggedIn) {
    return null;
  }

  const handleLogout = async () => {
    try {
      setIsOpen(false);
      await logout();
      router.replace('/');
    } catch (error) {
      console.error('Logout failed', error);
    }
  };

  return (
    <DropdownMenu
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={onToggle => (
        <TouchableOpacity onPress={() => onToggle()} style={styles.avatarButton}>
          <View style={styles.avatar}>
            <Text style={styles.avatarText}>{user?.email?.charAt(0).toUpperCase() || 'U'}</Text>
          </View>
        </TouchableOpacity>
      )}
      align={'end'}>
      <UserMenuContent onLogout={handleLogout} />
    </DropdownMenu>
  );
}

const styles = StyleSheet.create({
  container: {
    marginLeft: 16,
  },
  avatarButton: {
    padding: 4,
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: Colors.light.primary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatarText: {
    color: 'white',
    fontSize: 16,
    fontWeight: '600',
  },
});
